// 앱 전체 툴팁: 브라우저 기본 title 툴팁은 지연(약 1초)을 바꿀 수 없어서,
// title 속성을 가로채 TOOLTIP_DELAY_MS 뒤에 직접 그린 툴팁으로 대신 보여준다.
// - 기존 코드의 title="..." 은 수정할 필요 없음 (줄바꿈 \n 도 그대로 표시)
// - 마우스 이벤트가 오지 않는 disabled 버튼 등은 브라우저 기본 툴팁이 그대로 동작
// - 터치(모바일): 마우스를 올릴 수 없으므로 '…' 으로 잘린 글자(title 이 있는 요소)를 누르면 전체 내용을 바로 보여줌.
//   잘리지 않은 요소(버튼 등)는 누르는 동작을 방해하지 않도록 툴팁을 띄우지 않음
export const TOOLTIP_DELAY_MS = 500;
export const TOUCH_TOOLTIP_HIDE_MS = 5000;

export function installGlobalTooltip() {
  const tip = document.createElement('div');
  Object.assign(tip.style, {
    position: 'fixed', display: 'none', zIndex: '2147483000', pointerEvents: 'none',
    maxWidth: '420px', padding: '6px 10px', borderRadius: '6px', background: '#1e293b', color: '#fff',
    fontSize: '12px', lineHeight: '1.5', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
    boxShadow: '0 4px 12px rgba(0,0,0,0.25)', fontWeight: '400', textAlign: 'left',
  });
  tip.setAttribute('role', 'tooltip');
  document.body.appendChild(tip);

  let timer = null, cur = null, saved = null, x = 0, y = 0;
  let touchTimer = null, touchEl = null;

  const restore = () => {
    if (cur && saved != null && !cur.hasAttribute('title')) cur.setAttribute('title', saved);
    cur = null; saved = null;
  };
  const hide = () => {
    clearTimeout(timer); timer = null;
    clearTimeout(touchTimer); touchTimer = null; touchEl = null;
    tip.style.display = 'none';
    restore();
  };
  const show = () => {
    timer = null;
    if (!cur || !cur.isConnected) { hide(); return; }
    tip.style.display = 'block';
    const w = tip.offsetWidth, h = tip.offsetHeight, vw = window.innerWidth, vh = window.innerHeight;
    let left = Math.min(x + 12, vw - w - 8);
    let top = y + 20;
    if (top + h > vh - 8) top = Math.max(8, y - h - 12); // 아래 공간이 부족하면 위로
    tip.style.left = `${Math.max(8, left)}px`;
    tip.style.top = `${top}px`;
  };

  const onOver = (e) => {
    if (cur && cur.contains(e.target)) return; // 같은 요소 안에서 이동
    const el = e.target.closest ? e.target.closest('[title]') : null;
    if (!el) return;
    hide();
    const t = el.getAttribute('title');
    if (!t || !t.trim()) return;
    cur = el; saved = t;
    el.removeAttribute('title'); // 기본 툴팁이 같이 뜨지 않도록 잠시 제거 (mouseout 때 복원)
    tip.textContent = t;
    timer = setTimeout(show, TOOLTIP_DELAY_MS);
  };
  // ---- 터치: 잘린 글자를 누르면 전체 내용 표시 ----
  const isTouchLike = (e) => {
    if (e.pointerType === 'touch' || e.pointerType === 'pen') return true;
    if (typeof window.matchMedia === 'function' && window.matchMedia('(hover: none), (pointer: coarse)').matches) return true;
    return window.innerWidth <= 820;
  };
  const isTruncated = (el) =>
    el.scrollWidth > el.clientWidth + 1 || Array.from(el.querySelectorAll('*')).some(c => c.scrollWidth > c.clientWidth + 1);
  const onTap = (e) => {
    if (!isTouchLike(e)) return;
    const el = e.target.closest ? e.target.closest('[title]') : null;
    const same = el && el === touchEl;
    hide();
    if (!el || same) return; // 다른 곳을 누르면 닫기, 같은 곳을 다시 누르면 토글로 닫기
    const t = el.getAttribute('title');
    if (!t || !t.trim() || !isTruncated(el)) return;
    touchEl = el;
    tip.textContent = t;
    tip.style.maxWidth = `${Math.min(420, window.innerWidth - 16)}px`;
    tip.style.display = 'block';
    const r = el.getBoundingClientRect();
    const w = tip.offsetWidth, h = tip.offsetHeight, vw = window.innerWidth, vh = window.innerHeight;
    tip.style.left = `${Math.max(8, Math.min(r.left, vw - w - 8))}px`;
    tip.style.top = `${r.bottom + 6 + h > vh - 8 ? Math.max(8, r.top - h - 6) : r.bottom + 6}px`;
    touchTimer = setTimeout(hide, TOUCH_TOOLTIP_HIDE_MS);
  };

  const onOut = (e) => { if (cur && !cur.contains(e.relatedTarget)) hide(); };
  const onMove = (e) => { x = e.clientX; y = e.clientY; };

  document.addEventListener('mouseover', onOver, true);
  document.addEventListener('mouseout', onOut, true);
  document.addEventListener('mousemove', onMove, true);
  document.addEventListener('click', onTap, true);
  ['mousedown', 'keydown', 'wheel', 'scroll', 'blur'].forEach(ev => window.addEventListener(ev, hide, true));

  return () => {
    hide();
    document.removeEventListener('mouseover', onOver, true);
    document.removeEventListener('mouseout', onOut, true);
    document.removeEventListener('mousemove', onMove, true);
    document.removeEventListener('click', onTap, true);
    ['mousedown', 'keydown', 'wheel', 'scroll', 'blur'].forEach(ev => window.removeEventListener(ev, hide, true));
    tip.remove();
  };
}
